<template>
  <v-dialog :value="downloadDialog" persistent width="50%">
    <v-card>
      <v-card-text class="pt-4 pb-4">
        <v-layout row wrap class="px-3">
          <v-flex xs12 class="text-xs-center mb-3">
            <v-icon class="f3-5em k-orange-linear-text">{{icon}}</v-icon>
          </v-flex>
          <v-flex xs12 class="text-xs-center f1-1em my-2">
            {{message}}
          </v-flex>
          <v-flex xs12 class="text-xs-center f1-1em my-2" v-if="file.filename">
            {{file.filename.replace('.csv', '')}}
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-btn 
              class="k-orange-linear-text k-orange-linear-underline elevation-0"
              round
              v-on="{ click: () => file.filename ? downloadFile() : doSomething() } "
            >
              {{buttonText}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      file: {},
    };
  },
  computed: {
    ...mapGetters([
      'downloadItems',
      'downloadDialog',
    ]),
    icon() {
      return this.file.filename ? 'fas fa-download' : 'fas fa-info';
    },
    message() {
      return this.file.filename ? '¡Se ha generado su reporte a de manera exitosa!' : this.file.message || 'Ocurrió un error';
    },
    buttonText() {
      return this.file.filename ? 'DESCARGAR' : 'CERRAR';
    },
  },
  methods: {
    doSomething() {
      if (this.message === 'Segmentos actualizados') {
        if (this.$route.path === '/reports/segmentation') {
          location.reload();
        }
      }
      this.removeFirst();
    },
    downloadFile() {
      this.axios({
        url: `/reports/download?file=${this.file.filename}`,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        if (!window.navigator.msSaveOrOpenBlob) {
          // BLOB NAVIGATOR
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.file.filename);
          document.body.appendChild(link);
          link.click();
        } else {
          // BLOB FOR EXPLORER 11
          window.navigator.msSaveOrOpenBlob(response.data, this.file);
        }
        this.removeFirst();
      });
    },
    removeFirst() {
      this.$store.commit('SET_DOWNLOAD_DIALOG', false);
      this.$store.commit('PULL_FIRST_DOWNLOAD_ITEM');
    },
  },
  watch: {
    downloadItems: {
      deep: true,
      handler() {
        if (this.downloadItems.length > 0) {
          this.file = this.downloadItems[0];
          this.$store.commit('SET_DOWNLOAD_DIALOG', true);
        }
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/DownloadModal.vue